// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"d6f68a9443ce0fc1fea0","544":"cde2b252ee3342cc23c6"}[chunkId] + ".js";
};